module.exports = __webpack_public_path__ + "img/double.87e25592.webp";